module.exports = __webpack_public_path__ + "img/icon-corporate.c7dfddc3.png";